import axiosInstance from '@/utils/api.js'

var state = {
  ipPools: []
}

var getters = {
  IP_POOLS: (state) => {
    return state.ipPools
  }
}

var mutations = {
  SET_IP_POOLS: (state, payload) => {
    state.ipPools = payload
  }
}

var actions = {
  GET_IP_POOLS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/ippools')
    if (result.status === 200) {
      context.commit('SET_IP_POOLS', result.data)
    }
  },
  CREATE_IP_POOLS: (context, payload) => {
    return axiosInstance.post('/settings/ippools', payload)
  },
  UPDATE_IP_POOLS: (context, payload) => {
    return axiosInstance.put('/settings/ippools', payload)
  },
  DELETE_IP_POOLS: (context, payload) => {
    return axiosInstance.delete('/settings/ippools?pool_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/ipPools.js